export const invoiceDeliveryEn = {
  "invoiceDelivery.pdfLanguage": "PDF language",
  "invoiceDelivery.pdfTemplate": "PDF design",
  "invoiceDelivery.estonian": "Estonian",
  "invoiceDelivery.english": "English",
  "invoiceDelivery.standard": "Standard",
  "invoiceDelivery.compact": "Compact",
  "invoiceDelivery.optionsNotice": "Saved for this invoice and used for previews, downloads and new emails. Previous email attachments retain their original format.",
  "invoiceDelivery.optionsError": "Could not save the PDF options. Try again.",
  "invoiceDelivery.savePreview": "Save and preview PDF",
  "invoiceDelivery.title": "Invoice PDF and email",
  "invoiceDelivery.preview": "Preview invoice PDF",
  "invoiceDelivery.previewDraft": "Preview draft PDF",
  "invoiceDelivery.previewAttachment": "View attached PDF",
  "invoiceDelivery.send": "Send invoice by email",
  "invoiceDelivery.recipient": "Recipient email",
  "invoiceDelivery.replyTo": "Reply-to email (optional)",
  "invoiceDelivery.subject": "Subject",
  "invoiceDelivery.message": "Message",
  "invoiceDelivery.sender": "Requested by",
  "invoiceDelivery.requestedAt": "Requested at",
  "invoiceDelivery.finishedAt": "Last outcome at",
  "invoiceDelivery.defaultSubject": "Invoice {{number}}",
  "invoiceDelivery.defaultMessage": "Please find attached invoice {{number}}. Thank you.",
  "invoiceDelivery.attachmentNotice": "The confirmed invoice PDF will be attached. Other invoice attachments are not included. Email is sent through Andmera's configured email service.",
  "invoiceDelivery.sendConfirm": "Send the confirmed invoice PDF to {{recipient}}?",
  "invoiceDelivery.queuedNotice": "Invoice email queued. Its sending status appears below.",
  "invoiceDelivery.sentNotice": "Sent means the email service accepted the message. Inbox delivery is not confirmed.",
  "invoiceDelivery.history": "Email delivery history",
  "invoiceDelivery.empty": "No invoice emails have been requested yet.",
  "invoiceDelivery.queued": "Queued",
  "invoiceDelivery.sending": "Sending",
  "invoiceDelivery.sent": "Sent",
  "invoiceDelivery.failed": "Failed",
  "invoiceDelivery.unknown": "Outcome unknown",
  "invoiceDelivery.retry": "Retry sending",
  "invoiceDelivery.retryConfirm": "Retry sending the same invoice PDF and message to {{recipient}}?",
  "invoiceDelivery.retryUnknown": "The previous email may already have been sent. Check with {{recipient}} before retrying. Send it again, accepting a possible duplicate?",
  "invoiceDelivery.notConfigured": "Email sending is not configured. Contact your administrator, then retry.",
  "invoiceDelivery.rejected": "The email service rejected the message. Check the recipient and email service settings.",
  "invoiceDelivery.uncertain": "The sending outcome could not be confirmed. Check before retrying.",
  "invoiceDelivery.previewError": "Could not load the invoice PDF. Try again.",
  "invoiceDelivery.sendError": "Could not queue the invoice email. Check the details and try again.",
  "invoiceDelivery.retryError": "Could not retry sending. Refresh the history and try again.",
  "invoiceDelivery.historyError": "Could not load delivery history. Try refreshing.",
  "invoiceDelivery.older": "Older deliveries",
  "invoiceDelivery.newer": "Newer deliveries",
}

export const invoiceDeliveryEt: Record<keyof typeof invoiceDeliveryEn, string> = {
  "invoiceDelivery.pdfLanguage": "PDF-i keel",
  "invoiceDelivery.pdfTemplate": "PDF-i välimuse mall",
  "invoiceDelivery.estonian": "Eesti",
  "invoiceDelivery.english": "Inglise",
  "invoiceDelivery.standard": "Standardne",
  "invoiceDelivery.compact": "Kompaktne",
  "invoiceDelivery.optionsNotice": "Valikud salvestatakse selle arve jaoks ning neid kasutatakse eelvaates, allalaadimisel ja uutes e-kirjades. Varasemate e-kirjade manuste vorming säilib.",
  "invoiceDelivery.optionsError": "PDF-i valikute salvestamine ebaõnnestus. Proovi uuesti.",
  "invoiceDelivery.savePreview": "Salvesta ja vaata PDF-i eelvaadet",
  "invoiceDelivery.title": "Arve PDF ja e-post",
  "invoiceDelivery.preview": "Arve PDF-i eelvaade",
  "invoiceDelivery.previewDraft": "Mustandi PDF-i eelvaade",
  "invoiceDelivery.previewAttachment": "Vaata lisatud PDF-i",
  "invoiceDelivery.send": "Saada arve e-postiga",
  "invoiceDelivery.recipient": "Saaja e-posti aadress",
  "invoiceDelivery.replyTo": "Vastuse e-posti aadress (valikuline)",
  "invoiceDelivery.subject": "Teema",
  "invoiceDelivery.message": "Sõnum",
  "invoiceDelivery.sender": "Saatmise taotleja",
  "invoiceDelivery.requestedAt": "Taotluse aeg",
  "invoiceDelivery.finishedAt": "Viimase tulemuse aeg",
  "invoiceDelivery.defaultSubject": "Arve {{number}}",
  "invoiceDelivery.defaultMessage": "Manuses on arve {{number}}. Aitäh!",
  "invoiceDelivery.attachmentNotice": "Lisatakse kinnitatud arve PDF. Arve muid manuseid ei lisata. Kiri saadetakse Andmeras seadistatud e-posti teenuse kaudu.",
  "invoiceDelivery.sendConfirm": "Kas saata kinnitatud arve PDF aadressile {{recipient}}?",
  "invoiceDelivery.queuedNotice": "Arve e-kiri on saatmise ootel. Saatmise olekut näed allpool.",
  "invoiceDelivery.sentNotice": "Saadetud tähendab, et e-posti teenus võttis kirja vastu. Postkasti kohaletoimetamine ei ole kinnitatud.",
  "invoiceDelivery.history": "E-kirjade saatmise ajalugu",
  "invoiceDelivery.empty": "Ühtegi arve e-kirja pole veel saatmiseks esitatud.",
  "invoiceDelivery.queued": "Ootel",
  "invoiceDelivery.sending": "Saatmisel",
  "invoiceDelivery.sent": "Saadetud",
  "invoiceDelivery.failed": "Ebaõnnestunud",
  "invoiceDelivery.unknown": "Tulemus teadmata",
  "invoiceDelivery.retry": "Proovi uuesti saata",
  "invoiceDelivery.retryConfirm": "Kas saata sama arve PDF ja sõnum uuesti aadressile {{recipient}}?",
  "invoiceDelivery.retryUnknown": "Eelmine kiri võib olla juba saadetud. Enne uuesti proovimist kontrolli seda saajaga {{recipient}}. Kas saata uuesti, arvestades võimaliku korduva kirjaga?",
  "invoiceDelivery.notConfigured": "E-kirjade saatmine ei ole seadistatud. Võta ühendust administraatoriga ja proovi seejärel uuesti.",
  "invoiceDelivery.rejected": "E-posti teenus lükkas kirja tagasi. Kontrolli saajat ja e-posti teenuse seadistusi.",
  "invoiceDelivery.uncertain": "Saatmise tulemust ei saanud kinnitada. Kontrolli enne uuesti proovimist.",
  "invoiceDelivery.previewError": "Arve PDF-i laadimine ebaõnnestus. Proovi uuesti.",
  "invoiceDelivery.sendError": "Arve e-kirja lisamine saatmisjärjekorda ebaõnnestus. Kontrolli andmeid ja proovi uuesti.",
  "invoiceDelivery.retryError": "Uuesti saatmine ebaõnnestus. Värskenda ajalugu ja proovi uuesti.",
  "invoiceDelivery.historyError": "Saatmise ajaloo laadimine ebaõnnestus. Proovi värskendada.",
  "invoiceDelivery.older": "Vanemad saatmised",
  "invoiceDelivery.newer": "Uuemad saatmised",
}

export const invoiceDeliveryRu: Record<keyof typeof invoiceDeliveryEn, string> = {
  "invoiceDelivery.pdfLanguage": "Язык PDF",
  "invoiceDelivery.pdfTemplate": "Оформление PDF",
  "invoiceDelivery.estonian": "Эстонский",
  "invoiceDelivery.english": "Английский",
  "invoiceDelivery.standard": "Стандартное",
  "invoiceDelivery.compact": "Компактное",
  "invoiceDelivery.optionsNotice": "Настройки сохраняются для этого счёта и используются при предпросмотре, скачивании и отправке новых писем. Вложения ранее отправленных писем сохраняют исходное оформление.",
  "invoiceDelivery.optionsError": "Не удалось сохранить настройки PDF. Повторите попытку.",
  "invoiceDelivery.savePreview": "Сохранить и просмотреть PDF",
  "invoiceDelivery.title": "PDF счёта и отправка по почте",
  "invoiceDelivery.preview": "Предпросмотр PDF счёта",
  "invoiceDelivery.previewDraft": "Предпросмотр PDF черновика",
  "invoiceDelivery.previewAttachment": "Посмотреть вложенный PDF",
  "invoiceDelivery.send": "Отправить счёт по почте",
  "invoiceDelivery.recipient": "Электронная почта получателя",
  "invoiceDelivery.replyTo": "Адрес для ответа (необязательно)",
  "invoiceDelivery.subject": "Тема",
  "invoiceDelivery.message": "Сообщение",
  "invoiceDelivery.sender": "Кто запросил отправку",
  "invoiceDelivery.requestedAt": "Время запроса",
  "invoiceDelivery.finishedAt": "Время последнего результата",
  "invoiceDelivery.defaultSubject": "Счёт {{number}}",
  "invoiceDelivery.defaultMessage": "Во вложении счёт {{number}}. Спасибо!",
  "invoiceDelivery.attachmentNotice": "К письму будет приложен PDF подтверждённого счёта. Другие вложения счёта не включаются. Письмо отправляется через почтовую службу, настроенную в Andmera.",
  "invoiceDelivery.sendConfirm": "Отправить PDF подтверждённого счёта на адрес {{recipient}}?",
  "invoiceDelivery.queuedNotice": "Письмо со счётом поставлено в очередь. Статус отправки показан ниже.",
  "invoiceDelivery.sentNotice": "Статус «Отправлено» означает, что почтовая служба приняла письмо. Доставка в почтовый ящик не подтверждена.",
  "invoiceDelivery.history": "История отправки писем",
  "invoiceDelivery.empty": "Отправка писем с этим счётом ещё не запрашивалась.",
  "invoiceDelivery.queued": "В очереди",
  "invoiceDelivery.sending": "Отправляется",
  "invoiceDelivery.sent": "Отправлено",
  "invoiceDelivery.failed": "Не удалось отправить",
  "invoiceDelivery.unknown": "Результат неизвестен",
  "invoiceDelivery.retry": "Повторить отправку",
  "invoiceDelivery.retryConfirm": "Повторно отправить тот же PDF счёта и сообщение на адрес {{recipient}}?",
  "invoiceDelivery.retryUnknown": "Предыдущее письмо уже могло быть отправлено. Уточните это у получателя {{recipient}} перед повторной отправкой. Отправить ещё раз, допуская получение дубликата?",
  "invoiceDelivery.notConfigured": "Отправка почты не настроена. Обратитесь к администратору, затем повторите попытку.",
  "invoiceDelivery.rejected": "Почтовая служба отклонила письмо. Проверьте получателя и настройки почтовой службы.",
  "invoiceDelivery.uncertain": "Не удалось подтвердить результат отправки. Проверьте его перед повторной попыткой.",
  "invoiceDelivery.previewError": "Не удалось загрузить PDF счёта. Повторите попытку.",
  "invoiceDelivery.sendError": "Не удалось поставить письмо со счётом в очередь. Проверьте данные и повторите попытку.",
  "invoiceDelivery.retryError": "Не удалось повторить отправку. Обновите историю и повторите попытку.",
  "invoiceDelivery.historyError": "Не удалось загрузить историю отправки. Попробуйте обновить её.",
  "invoiceDelivery.older": "Более ранние отправки",
  "invoiceDelivery.newer": "Более поздние отправки",
}
